import { BackendControlledComponents, IEventDetails } from 'meta/backendControlled/structure'

type Path = string

export type BackendControlledState = Record<Path, BackendControlledComponents & { eventDetails?: IEventDetails }>

export const initialState: BackendControlledState = {}
